import { Navigate, useLocation } from 'react-router-dom';
import { LoadingSpinner } from '@/components/ui/loading-spinner';
import { usePortalAuthStore } from '@/store/portalAuthStore';
import { useTranslation } from '@/hooks/useTranslation';

interface PortalProtectedRouteProps {
  children: React.ReactNode;
}

/**
 * Bundle K Phase K1D — guards `/portal/*` routes that require an
 * authenticated customer. Mirrors `ProtectedRoute` for the admin SPA but:
 *   - reads from `usePortalAuthStore` (not `authStore`)
 *   - redirects to `/portal/login` (not `/login`)
 *   - has no permission gating in K1
 */
export function PortalProtectedRoute({ children }: PortalProtectedRouteProps) {
  const { t } = useTranslation('customer_portal');
  const isAuthenticated = usePortalAuthStore((s) => s.isAuthenticated);
  const isLoading = usePortalAuthStore((s) => s.isLoading);
  const isInitialized = usePortalAuthStore((s) => s.isInitialized);
  const location = useLocation();

  if (!isInitialized || isLoading) {
    return <LoadingSpinner text={t('loading.verifying')} />;
  }

  if (!isAuthenticated) {
    return <Navigate to="/portal/login" state={{ from: location }} replace />;
  }

  return <>{children}</>;
}
